/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Timeframe } from '../models/Timeframe';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TimeframesService {

    /**
     * List Timeframes
     * Timeframes sorted by start. Only admins see hidden timeframes.
     * @returns Timeframe Successful Response
     * @throws ApiError
     */
    public static listTimeframesApiV1TimeframesGet(): CancelablePromise<Array<Timeframe>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/timeframes',
        });
    }

}
